module.exports = __webpack_public_path__ + "img/292.f82034b5.jpg";